// *********** start: kit product subscription widget overwrite ************

(function () {
  'use strict';

  var CONFIG = {
    productHandle: 'total-gut-reset-kit',
    subscribeText: 'Subscribe Sugar Shift® after 90 days',
    priceNote: ' ($39.99 after 90 days)',
    priceMarkerClass: 'sr-after-90-note'
  };

  // 1) Only run on the target product page
  function currentHandle() {
    var m = (location.pathname || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  if (currentHandle() !== CONFIG.productHandle) return;

  // Deep query that pierces open shadow roots (Recharge renders inside shadow DOM)
  function deepQueryAll(selector, root) {
    root = root || document;
    var out = [];
    (function walk(node) {
      if (!node.querySelectorAll) return;
      node.querySelectorAll(selector).forEach(function (el) { out.push(el); });
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) walk(el.shadowRoot);
      });
    })(root);
    return out;
  }

  function getSubscribeContainer() {
    var input =
      deepQueryAll('input[name="purchaseOption"][value="subscription"]')[0] ||
      deepQueryAll('input.rc-purchase-option__input[value="subscription"]')[0];
    if (!input) return null;
    return input.closest('.rc-purchase-option__label') ||
           input.closest('.rc-purchase-option') ||
           input.parentElement;
  }

  function updateText(container) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === 'Subscribe') {           // exact match => idempotent
        node.nodeValue = node.nodeValue.replace('Subscribe', CONFIG.subscribeText);
      }
    }
  }

  function updatePrice(container) {
    var prices = container.querySelector('.rc-purchase-option__prices');
    if (!prices || prices.querySelector('.' + CONFIG.priceMarkerClass)) return; // already added
    var note = document.createElement('span');
    note.className = CONFIG.priceMarkerClass;
    note.textContent = CONFIG.priceNote;
    note.style.fontWeight = 'normal';
    prices.appendChild(note);
  }

  function apply() {
    var container = getSubscribeContainer();
    if (!container) return;
    updateText(container);
    updatePrice(container);
  }

  // Debounced runner
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 50); }

  // Observe light DOM + every shadow root; re-scan for new ones as the widget mounts
  var seen = new WeakSet();
  function observe(root) {
    if (!root || seen.has(root)) return;
    seen.add(root);
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, characterData: true
    });
  }
  function scan(root) {
    root = root || document;
    observe(root === document ? document.documentElement : root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) { observe(el.shadowRoot); scan(el.shadowRoot); }
    });
  }

  function boot() { scan(document); apply(); }
  boot();

  // Catch the widget loading late (async) for the first ~30s
  var n = 0, iv = setInterval(function () {
    scan(document); apply();
    if (++n > 60) clearInterval(iv);
  }, 500);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();

// ************end************

// ************ start: sugar shift bundle product widget overwrite ************

(function () {
  'use strict';

  var CONFIG = {
    productHandles: ['sugar-and-sleep-support-kit', 'stress-and-sugar-support-kit']
  };

  function currentHandle() {
    var m = (location.pathname || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  if (CONFIG.productHandles.indexOf(currentHandle()) === -1) return;

  function deepQueryAll(selector, root) {
    root = root || document;
    var out = [];
    (function walk(node) {
      if (!node.querySelectorAll) return;
      node.querySelectorAll(selector).forEach(function (el) { out.push(el); });
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) walk(el.shadowRoot);
      });
    })(root);
    return out;
  }

  // Capture leading/trailing whitespace in groups 1 and 3 (or 1 and 2 for badge)
  // instead of trimming it away, so the anchors actually match the raw text node
  // and we can reconstruct the original spacing exactly.
  var BADGE_RE   = /^(\s*)Save\s+(\d+(?:\.\d+)?)%(\s*)$/i;
  var BENEFIT_RE = /^(\s*)Save\s+(\d+(?:\.\d+)?)%\s+on every order(\s*)$/i;

  function updateTextNodes(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      if (!raw || !raw.trim()) continue;

      var newValue = null;

      var badgeMatch = raw.match(BADGE_RE);
      if (badgeMatch) {
        newValue = badgeMatch[1] + 'Additional ' + badgeMatch[2] + '% Off' + badgeMatch[3];
      } else {
        var benefitMatch = raw.match(BENEFIT_RE);
        if (benefitMatch) {
          newValue = benefitMatch[1] + 'Save an additional ' + benefitMatch[2] + '% on every order' + benefitMatch[3];
        }
      }

      // Guard: never assign nodeValue unless it's actually different.
      // Reassigning an identical string still fires a characterData
      // mutation, which would re-trigger the MutationObserver and loop
      // forever without ever changing anything on screen.
      if (newValue !== null && newValue !== raw) {
        node.nodeValue = newValue;
      }
    }
  }

  function apply() {
    updateTextNodes(document.documentElement);
    deepQueryAll('*').forEach(function (el) {
      if (el.shadowRoot) updateTextNodes(el.shadowRoot);
    });
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 50); }

  var seen = new WeakSet();
  function observe(root) {
    if (!root || seen.has(root)) return;
    seen.add(root);
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, characterData: true
    });
  }
  function scan(root) {
    root = root || document;
    observe(root === document ? document.documentElement : root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) { observe(el.shadowRoot); scan(el.shadowRoot); }
    });
  }

  function boot() { scan(document); apply(); }
  boot();

  var n = 0, iv = setInterval(function () {
    scan(document); apply();
    if (++n > 60) clearInterval(iv);
  }, 500);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();

// ************END************